import React, { useEffect, useState } from 'react'
import axios from 'axios'
import "../styles/AdminApplications.css"
import Pagination from '@material-ui/lab/Pagination';
import { upperFirst } from 'lodash'
import { useDispatch } from 'react-redux'
import { ApiURL } from '../constants/ApiUrl'
import { useHistory } from 'react-router-dom'
import * as Yup from "yup"
import { TextField, Button } from '@material-ui/core'
import "../styles/FormPage1.css"

function NoticePage() {
    const [searchdata, setSearchdata] = useState("")
    const [name, setName] = useState("")
    const [Notice, setNotice] = useState("")
    const [Search, setSearch] = useState('')
    const [textList, setTextList] = useState([])
    const [userType, setuserType] = useState('all')
    const [status, setstatus] = useState('all')
    const [AppList, setAppList] = useState([])
    const [Page, setPage] = useState(0)
    const [TotalPages, setTotalPages] = useState(0)
    const [TotalItems, setTotalItems] = useState(0)
    const dispatch = useDispatch();
    const history = useHistory();
    

    const handleAdd = () => {
        history.push('/admin/NoticeForm')
    }
    useEffect(() => {

        console.log("Page", Page);
        if(Page > 0)
            getNotices(Page, 10);
        else
            getNotices(0, 10);

    }, [Page, userType,status])
    // useEffect(() => {
    //     getNotices(0, 10);
    // }, [Page, userType,status])

    const handleView = async (value) => {
        localStorage.setItem("Notice", value)
        history.replace(`/admin/NoticesView/${value}`)
    }
    const onKeyDown = (e) => {
        console.log(e.key);
        if (e.key === 'Enter') {
            getNotices(Page, 10);
        }
    }
    const handlePageChange = (e, value) => {
        setPage(value - 1);
    }

    const getNotices = async (page, limit) => {
        // console.log(status,"sttttttt")
        const textlist = []
        const result = await axios.get(`${ApiURL}/api/get_notices_for_admin?page=${page}&limit=${limit}&userType=${userType}&status=${status}`)
        // console.log(result.data.data[0].text,"reeeeeee")
        if(result.data.totalItems > 0)
        {
            result.data.data.map((element) => {
                console.log(element,"fjk")
                if (element.text != null)
                {
                    const data = element.text.slice(0, 130)
                    textlist.push(data)
                }
                    
            })
            setTextList(textlist)
            setAppList(result.data.data);
            setTotalPages(result.data.totalPages);
            setTotalItems(result.data.totalItems);
        }
        
    }

    const handleChange = (e) => {
        setName(e.target.value)

    }
    const handleSearch = async () => {
        console.log(userType,status);
        const result = await axios.get(`${ApiURL}/api/searchnotice?search=${name}&type=${userType}&status=${status}&page=${Page}&limit=${10}`)
        setAppList(result.data.data);
        setTotalPages(result.data.totalPages);
        setTotalItems(result.data.totalItems);
    }

    return (
        <>
            <div className="admMem">
                <h1>Notices</h1>
                <div className="searchContainer" style={{ flexDirection: 'row', gap: '20px' }}>
                    <select className="NewSelects" onChange={(e) => setuserType(e.target.value)}>
                        <option value='all'>All</option>
                        <option value='All'>All Members</option>
                        <option value='Life Member'>Life Member</option>
                        <option value='Student'>Student</option>
                        <option value='Associate'>Associate</option>
                    </select>
                    <select className="NewSelects" onChange={(e) => setstatus(e.target.value)}>
                        <option value='all'>All</option>
                        <option value='Active'>Active</option>
                        <option value='Inactive'>Inactive</option>
                    </select>
                    <div style={{ width: '50%' }}>
                        <TextField style={{ width: '50%' }} placeholder="Search" onChange={handleChange} label="Search Title" onKeyDown={onKeyDown}
                        />
                        <Button variant="contained" onClick={handleSearch} >Search</Button>
                    </div>
                    <Button variant="contained" color="primary" style={{fontSize:"15px",position:"relative",height:"50px",right:"60px"}}onClick={handleAdd} >Add New Notice</Button>

                </div>
                <Pagination count={TotalPages} page={Page + 1} onChange={handlePageChange} variant="outlined" shape="rounded" />
                <p><b>{TotalItems} records found.</b></p>
                <table className="appTable">
                    <tr>
                        <th>S.No</th>
                        <th>User Group</th>
                        <th>Title</th>
                        {/* <th>Notice</th> */}
                        <th>Date</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                    {
                        AppList.map((item, index) => (
                            <tr key={item.memberID}>
                                <td>{(Page * 10) + (index + 1)}</td>
                                <td>{item.userType}</td>
                                <td>{item.subject}</td>
                                {/* <td >{textList[index]}</td> */}
                                <td style={{ width: "150px" }}>{new Date(item.createdAt).toDateString()}</td>
                                <td>{item.status}</td>
                                <td><Button variant="contained" color="primary"
                                    onClick={() => handleView(item._id)}
                                >View</Button></td>
                            </tr>
                        ))
                    }
                </table>
            </div>



        </>
    )
}


export default NoticePage
